import { cn } from '@/platform/lib/utils';

const sizes = {
    h1: 'text-3xl',
    h2: 'text-2xl',
    h3: 'text-xl',
    h4: 'text-lg',
    h5: 'text-base',
    h6: 'text-sm',
};

const Header = ({
    as: Component = 'h1',
    icon: Icon,
    subheader,
    className,
    children,
    ...props
}) => {
    const heading = (
        <Component
            className={cn(
                'font-semibold text-gray-900',
                sizes[Component] ?? sizes.h1,
                !Icon && !subheader && className
            )}
            {...props}
        >
            {children}
        </Component>
    );

    if (!Icon && !subheader) {
        return heading;
    }

    return (
        <div className={cn('flex items-center gap-3', className)}>
            {Icon && (
                <Icon
                    aria-hidden='true'
                    className='size-8 shrink-0 text-gray-900'
                />
            )}
            <div className='min-w-0'>
                {heading}
                {subheader && (
                    <p className='text-sm text-gray-500'>{subheader}</p>
                )}
            </div>
        </div>
    );
};

export default Header;
